import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { ClinicDetailQuery } from 'src/app/shared/state/clinic-detail/clinic-detail.query';
import { MessageService } from 'src/app/shared/state/message/message.service';
import { SettingsQuery } from 'src/app/shared/state/settings/settings.query';
import { UserQuery } from 'src/app/shared/state/user/user.query';
import { NavController } from '@ionic/angular';
import OneSignal from 'onesignal-cordova-plugin';
import { StorageService } from '../storage/storage.service';
import { appOnePush } from '../../../../../variables';

@Injectable({
    providedIn: 'root',
})
export class PushService {
    constructor(
        private router: Router,
        private userQuery: UserQuery,
        private messageService: MessageService,
        private ngZone: NgZone,
        private clinicDetailQuery: ClinicDetailQuery,
        private settingsQuery: SettingsQuery,
        private navCtrl: NavController,
        private storage: StorageService
    ) {}

    async initNotificationPush() {
        await this.storage.set('idDevice', '');
        if (Capacitor.isNativePlatform()) {
            this.initConfiguration();
        }
    }

    async initConfiguration() {
        // Initialize OneSignal
        OneSignal.initialize(appOnePush);
        await this.loginOneSignal();

        // Set notification opened handler
        OneSignal.Notifications.addEventListener('click', (event) => {
            // do something when a notification is opened
            const notificationData: any = event.notification;
            const systemKey = notificationData.additionalData?.SystemKey;
            const clinicId = notificationData.additionalData?.ClinicID;

            if (!systemKey || !clinicId) {
                console.log('Missing SystemKey or ClinicID in notification data');
                return;
            }

            this.ngZone.run(() => {
                if (
                    this.clinicDetailQuery.id === clinicId &&
                    this.settingsQuery.systemKeyURL === systemKey &&
                    this.userQuery.tokenId !== ''
                ) {
                    this.messageService.getMessages(null);
                }
            });

            this.ngZone.run(() => {
                /** Si estoy en un sk o un en una clínica distinta a la que voy a entrar, la hago root */
                if (
                    this.settingsQuery.systemKeyURL !== systemKey ||
                    this.clinicDetailQuery.id !== clinicId
                ) {
                    this.navCtrl.navigateRoot(
                        systemKey + '/' + clinicId + '/message'
                    );
                } else {
                    this.router.navigate([
                        systemKey + '/' + clinicId + '/message',
                    ]);
                }
            });
        });

        // Request permission and register for push
        OneSignal.Notifications.requestPermission(true).then((accepted) => {
            console.log('User accepted notifications: ' + accepted);
        });

        // Set subscription observer
        OneSignal.User.addEventListener('change', async (event) => {
            console.log('User state changed', event);
            try {
                this.loginOneSignal();
            } catch (error) {
                console.error('Error getting OneSignal User ID:', error);
            }
        });
    }

    private async loginOneSignal() {
        const onesignalId = await OneSignal.User.pushSubscription.getIdAsync();
        console.log('onesignalId', onesignalId);
        if (onesignalId) {
            this.storage.set('idDevice', onesignalId);
            OneSignal.login(onesignalId);
        }
    }
}
